import Vue from 'vue'
/* General views for handling lazy loading and loading errors */
import LoadingView from '../views/lazy/Loading'
import ErrorLoadingView from '../views/lazy/Error'

/**
 * Returns a component with lazy loading and two views to handle loading time and error if there is a timeout.
 * https://router.vuejs.org/guide/advanced/lazy-loading.html
 * https://vuejs.org/v2/guide/components-dynamic-async.html#Async-Components
 * @param {String} path Path relative to 'views' dir.
 * @param {String} [name] Optional. Name to set to the view.
 */
export function lazy(path, name) {
  name = name || path.replace(/\//g, '-').replace(/\.vue$/, '')
  return Vue.component(`LazyWrapper-${name}`, {
    render(createElement) { return createElement(name) },
    components: {
      [name]: () => ({
        component: import(/* webpackChunkName: "view-[request][index]" */`@/views/${path}`),
        loading: LoadingView,
        error: ErrorLoadingView,
        delay: 0,
        timeout: 30000
      })
    }
  })
}

export default lazy
